import client from '@/shared/apis/client'
import { RecordingSession } from '@/shared/types/recordingSession'
import { AudioSource, convertToMp3 } from './audio'

/**
 * グループセッション音声アップロード
 *
 * @param audioSource - 音声URL文字列またはFileオブジェクト
 * @param yakurekiIds - 対象YakurekiEvent IDの配列（2件以上）
 */
export const postRecordingSessionAudio = async (
  audioSource: AudioSource,
  yakurekiIds: string[],
  pharmacistId?: string,
  memoItems?: string[]
): Promise<RecordingSession> => {
  const blob =
    audioSource instanceof File
      ? audioSource
      : await fetch(audioSource).then((r) => r.blob())

  const mp3Blob = await convertToMp3(blob)
  const formData = new FormData()
  formData.append('audio', mp3Blob, 'audio.mp3')
  formData.append('yakureki_ids', JSON.stringify(yakurekiIds))
  if (pharmacistId) {
    formData.append('pharmacist_id', pharmacistId)
  }
  if (memoItems && memoItems.length > 0) {
    formData.append('memo_items', JSON.stringify(memoItems))
  }

  const response = await client.post<RecordingSession>(
    '/api/recording-sessions/upload_audio/',
    formData
  )
  return response.data
}
